import React from "react";
import { EditableText } from "@blueprintjs/core";
import api from "../../common/lib/api";
import { ApiWrapped } from "./ApiWrapped";
import Raw from "./Raw";
import ChangePassword from "./ChangePassword";
import ChangeNotificationSettings from "./ChangeNotificationSettings";

export default function AccountInfo({ session, token }) {
  return (
    <ApiWrapped
      session={session}
      token={token}
      endpoint="/account"
      renderCallback={function AccountInfo({ state, setState }) {
        function formValue(field) {
          return {
            value: state[field],
            onChange: (value) => setState((st) => ({ ...st, [field]: value })),
            onConfirm: async () => {
              await updateAccountName(state);
              console.log("done");
            },
          };
        }

        return (
          <div>
            <Raw json={state} />
            <div>
              <strong>First Name:</strong>{" "}
              <EditableText {...formValue("firstName")} />{" "}
            </div>
            <div>
              <strong>Last Name:</strong>{" "}
              <EditableText {...formValue("lastName")} />
            </div>
            <div>
              <strong>Email:</strong> {state.email}
            </div>
            <div>
              <strong>Mobile:</strong> {state.mobile}
            </div>
            <div>
              <strong>Splash Screens:</strong>
              <br />{" "}
              {Object.values(state.splashScreenUrls || {}).map(
                (image, index) => (
                  <img
                    key={image + index}
                    alt={image}
                    src={image}
                    style={{
                      maxHeight: "15em",
                    }}
                  />
                )
              )}
            </div>
            <div>
              <ChangePassword token={token} />
              <ChangeNotificationSettings token={token} />
            </div>
          </div>
        );
      }}
    />
  );
}

async function updateAccountName(state) {
  await api.patch("/account", {
    firstName: state.firstName,
    lastName: state.lastName,
  });
}
